import {
  UseMutationResult,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query'
import { useApiClient } from '@/hooks'
import { ExpenseDeclaration, APIErrorResponse } from '@/types'
import { unwrapErrorResponse, unwrapResponse } from '@/utils'
import { getUseExpensesKey } from '@/hooks'

export type PostExpenseDeclarationApprove = {
  validation_message: string
}

export const usePostExpenseDeclarationApprove = ({
  id,
}: Pick<ExpenseDeclaration, 'id'>): UseMutationResult<
  ExpenseDeclaration,
  APIErrorResponse,
  PostExpenseDeclarationApprove
> => {
  const client = useApiClient()

  const queryClient = useQueryClient()

  const expensesListKey = getUseExpensesKey()

  return useMutation(
    (params) =>
      client
        .post(`/hours_reporting/hr/expenses/${id}/approve/`, params)
        .then(unwrapResponse)
        .catch(unwrapErrorResponse),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(expensesListKey)
      },
    }
  )
}
